import BaseAPI from '@/xreports/apis/base'
class MembersService extends BaseAPI {
  constructor(props) {
    super(props)
  }

  // 创建用户
  createNewUser(data, type) {
    return this.post({
      url: `/member/manager/${type === 1 ? 'add' : 'edit'}`,
      data,
    })
  }
  // 停用启用用户
  enableOrDisableUser(data, type) {
    return this.get({
      url: `/member/manager/${type === 1 ? 'enable' : 'disable'}?userId=${data.userId}`,
    })
  }
  deleteUser(userId) {
    return this.get({
      url: `/member/manager/del?userId=${userId}`,
    })
  }

  // 用户详细信息列表
  getUserList(data) {
    return this.post({
      url: `/member/manager/list`,
      data,
    })
  }
  //查询酒店范围
  hotelZoomListByHotel(tenantId) {
    return this.get({
      url: `/cem/hotel/user/hotel-list?tenantId=${tenantId}`,
    })
  }

  // getHotelInfo() {
  //   return this.get({
  //     url: '/cem/hotel/user/info',
  //   })
  // }
  /****qms版成员管理 */
  // 获取当前用户的应用权限列表
  getCurrentUserRoles() {
    return this.get({
      url: '/member/manager/roles',
    })
  }
  // 取用户可操作的权限范围（系统，角色，用户类型，酒店） /member/manager/configurable/diff
  getUserAuths(data) {
    return this.post({
      url: '/member/manager/configurable/diff',
      data,
    })
  }
  rolesListByHotel(appName) {
    return this.get({
      url: `/member/manager/app/roles?clientId=${appName}`,
    })
  }
  // 获取角色对应应用下的所有菜单
  getCategoryMenu(appName) {
    return this.get({
      url: `/member/manager/menus-by-appcategory?clientIds=${appName}`,
    })
  }

  // 获取角色对应的菜单权限 /blade-system/menu/role-menus
  getCategoryAuth({ roleId }) {
    return this.get({
      url: `/member/manager/role-menus?roleIds=${roleId}`,
    })
  }

  // 获取用户数据权限
  getDataAuthInfo(userId) {
    return this.get({
      url: '/member/manager/data-authority/info',
      params: { userId },
    })
  }

  // qms获取酒店列表
  getQmsHotelList(data) {
    return this.post({
      url: '/member/manager/qms-hotel-list',
      data,
    })
  }

  // cem获取酒店列表
  getCemHotelList(data) {
    return this.post({
      url: '/member/manager/app/auth-hotel-list',
      data,
    })
  }

  //导入创建cem账号
  uploadExtensionJson(data) {
    return this.post({
      url: `/member/manager/batch-add`,
      responseType: 'blob',
      data,
    })
  }

  // 用户修改密码
  changePassword(data) {
    return this.post({
      url: `/member/manager/password/modify`,
      data,
    })
  }

  // 查询用户应用
  getUserApps(data) {
    return this.post({
      url: '/member/manager/user/apps',
      data,
    })
  }

  // 获取应用按钮权限
  getAppButtonList(userId) {
    return this.get({
      url: '/apollo/config?key=app-button',
    })
  }

  // 解绑公众号
  unbindWechat(params) {
    return this.get({
      url: '/member/manager/wx/unbind',
      params,
    })
  }

  /* 以下是有组织架构的成员管理接口 */
  // 获取组织架构 部门列表
  getOrgList(params) {
    return this.get({
      url: '/cem/dept/list',
      params,
    })
  }

  // 获取集团属性key
  getGroupKey(data) {
    return this.post({
      url: '/tenant/manager/group-attribute',
      data,
    })
  }

  // 获取集团属性value
  getGroupValue(params) {
    return this.get({
      url: '/cem/dept/tag-info',
      params,
    })
  }

  // 新增修改部门
  updateDepartment(data) {
    return this.post({
      url: '/cem/dept/add-or-update',
      data,
    })
  }

  // 删除部门
  delDepartment(data) {
    return this.post({
      url: '/cem/dept/delete',
      data,
    })
  }

  // 移动部门
  moveDepartment(data) {
    return this.post({
      url: '/cem/dept/move-dept-sort',
      data,
    })
  }

  // 获取应用及角色列表
  getAppAndRole(params) {
    return this.get({
      url: '/cem/dept/tenant-app-role',
      params,
    })
  }

  // 根据组织架构获取酒店列表
  getHotelListByOrg(data) {
    return this.post({
      url: '/cem/dept/dept-hotel-list',
      data,
    })
  }

  // 用户详情
  getUserDetail(params) {
    return this.get({
      url: '/member/manager/dept/data-authority/info',
      params,
    })
  }

  // 其他多店页面用 获取每个层级下的所有组织和酒店
  getDeptAndHotel(params) {
    return this.get({
      url: '/cem/dept/info-list',
      params,
    })
  }

  // 组织成员管理专用 获取每个层级下的所有组织和酒店
  getDeptAndHotelNew(params) {
    return this.get({
      url: '/cem/dept/info-list/no-app',
      params,
    })
  }

  // 根据部门获取可选应用和角色
  getAppAndRoleByDept(data) {
    return this.post({
      url: '/cem/dept/canSelectAppRole',
      data,
    })
  }

  // 新增、编辑账号
  updateOrgMember(data, type) {
    return this.post({
      url: `/member/manager/dept/${type === 1 ? 'add' : 'edit'}`,
      data,
    })
  }

  // 用户列表
  getUserListByOrg(data) {
    return this.post({
      url: `/member/manager/dept/list`,
      data,
    })
  }

  /* 以上是有组织架构的成员管理接口 */

  // 获取当前租户信息 包含成员管理类型
  getTenantInfo(data) {
    return this.post({
      url: '/tenant/manager/info',
      data,
    })
  }
}

export default new MembersService()
